module.exports = __webpack_public_path__ + "img/referee-admin-icon.de0a4dc8.svg";